export type EvCatalogSelectionOption = {
  label: string;
  powerKw: number;
  priceCents: number;
  versionKey: string;
  sourceDate: string;
  optionKey: string;
  siteKind: string;
  supplyPhase: string;
  [key: string]: unknown;
};

/** Only derive a catalog variant when both user choices are explicit and the active catalog contains that pair. */
export function resolveEvCatalogOption(
  siteKind: unknown,
  phase: unknown,
  catalog: readonly EvCatalogSelectionOption[] | undefined,
): EvCatalogSelectionOption | undefined {
  if ((siteKind !== "single_house" && siteKind !== "community") || (phase !== "mono" && phase !== "tri") || !catalog?.length) return undefined;
  const expectedSite = siteKind === "community" ? "community" : "home";
  const expectedSupply = phase === "tri" ? "three-phase" : "single";
  return catalog.find(option => option.siteKind === expectedSite && option.supplyPhase === expectedSupply);
}

/** Drop a persisted legacy/stale option unless it matches the current choices and active catalog. */
export function reconcileEvCatalogOption<T extends Record<string, unknown>>(
  need: T & { evOptionId?: unknown },
  catalog: readonly EvCatalogSelectionOption[] | undefined,
): T {
  const resolved = resolveEvCatalogOption(need.siteKind, need.phase, catalog);
  const next: Record<string, unknown> = { ...need };
  if (resolved) next.evOptionId = resolved.optionKey;
  else delete next.evOptionId;
  return next as T;
}
